import React from 'react';

import classNames from 'classnames';

import './table-footer-wrapper.scss';

interface TableFooterWrapperProps {
  left?: React.ReactNode;
  right?: React.ReactNode;
  blank?: boolean;
  auto?: boolean;
}

const TableFooterWrapper: React.FC<TableFooterWrapperProps> = ({
  left,
  right,
  blank,
  auto,
}) => (
  <div
    className={classNames('table-footer', {
      'table-footer--blank': blank,
      'table-footer--auto': auto,
    })}
  >
    <div className="table-footer__left">{left && left}</div>
    <div className="table-footer__right">{right && right}</div>
  </div>
);

export default TableFooterWrapper;
